module.exports = __webpack_public_path__ + "img/manual_stt.1e7190dc.svg";